import extend from '@/utils/vuex-extend';
import Base from './base';


export default extend(Base, {
    state: {
        visible: false
    },
    actions: {
        openDialog({ commit, dispatch, state }, payload) {
            commit('save', {
                visible: true,
                ...payload
            })
            dispatch('afterOpenDialog');
        },
        closeDialog({ commit, state }) {
			localStorage.removeItem("deliver.detail.open")
            commit('save', {
                visible: false
            })
        }
    }
})



// WEBPACK FOOTER //
// ./src/vuex-extend/dialog.js